import { Button, Result } from "antd";
import { Card } from "../material-old";
import { Link } from "react-router-dom";

interface Props {
  link?: string;
  description?: string;
  returnToMainPage?: boolean;
}

const defaultLink = "/";
const defaultDescription = "La página que buscas no existe";

export const NotFoundError: React.FC<Props> = ({
  link = defaultLink,
  description = defaultDescription,
  returnToMainPage = true,
}) => {
  return (
    <Card className="w-full h-screen flex justify-center items-center overflow-hidden">
      <Result
        status="404"
        title="404"
        subTitle={description}
        extra={
          returnToMainPage && (
            <Link to={link}>
              <Button type="primary">Volver a la página principal</Button>
            </Link>
          )
        }
      />
    </Card>
  );
};
